export default __webpack_public_path__ + "static/media/pic54.243ec7ee.jpg";